import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Auth } from 'aws-amplify';
import {
  DataGridContainer,
  GridContainer,
  LeftGrid,
  NoteHeading,
} from '../../Episode.Styled';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  dateFormat,
  EPISODE_QUALITY_ASSURANCE_LIST_URL,
  EPISODE_QUALITY_ASSURANCE_DETAIL_URL,
} from '../../../../constants';
import { getStopApi } from '../../../../services/StopApi/StopApi';
import { qualityAssurance } from '../../../../redux/episode/qualityAssuranceTab/qualityAssuranceSlice';
import QualityAssuranceDialog from './QualityAssuranceDialog';
import {
  getQualityAssuranceDetailForm,
  newQualityAssurance,
} from '../../../../redux/episode/qualityAssuranceTab/qualityAssuranceDetail/qualityAssuranceDetailSlice';

const QualityAssurance = (props) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  //const [formLoading, setFormLoading] = useState(false);
  const [qualityAssuranceData, setQualityAssuranceData] = useState({
    isLoading: false,
    data: [],
    pageSize: 10,
    total: '',
    page: 1,
  });

  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    qualityAssuranceData.page,
    qualityAssuranceData.pageSize,
  ]);

  const fetchData = async () => {
    setQualityAssuranceData((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${EPISODE_QUALITY_ASSURANCE_LIST_URL}/${episodeId}/QAReviews?PageNumber=${qualityAssuranceData.page}&PageSize=${qualityAssuranceData.pageSize}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response.data;
      setQualityAssuranceData((prveState) => ({
        ...prveState,
        isLoading: false,
        total: response.totalRows,
        data: json?.map((item, index) => ({
          ...item,
          id: index,
          QualityAssuranceReviewId: item.QualityAssuranceReviewId,
          reviewDate: item.reviewDate
            ? moment(item.reviewDate).format(dateFormat).split('T')[0]
            : '-',
          lastReviewDate: item.lastReviewDate
            ? moment(item.lastReviewDate).format(dateFormat).split('T')[0]
            : '-',
          nextReviewDate: item.nextReviewDate
            ? moment(item.nextReviewDate).format(dateFormat).split('T')[0]
            : '-',
        })),
      }));
    }).catch((e) => alert(e));
  };

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const qualityAssurancRowClick = (rowData) => {
    const qualityAssuranceDetailUrl = `${EPISODE_QUALITY_ASSURANCE_DETAIL_URL}${rowData.QualityAssuranceReviewId}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const qualityAssuranceList = {
      QualityAssuranceReviewId: rowData.QualityAssuranceReviewId,
      reviewDate: rowData.reviewDate,
      dateEarly: rowData.dateEarly,
      dateLate: rowData.dateLate,
    };
    setOpen(true);
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 600);
    dispatch(qualityAssurance(qualityAssuranceList));
    dispatch(
      getQualityAssuranceDetailForm({
        qualityAssuranceDetailUrl,
        authorization,
      })
    );
  };

  const openNewQualityAssurance = () => {
    const qualityAssuranceDetailForm = {
      newQualityAssurance: true,
      QualityAssuranceReviewId: 0,
      reviewDate: '',
      lastReviewDate: '',
      nextReviewDate: '',
      question1: 2,
      question2: 2,
      question3: 2,
      question4: 2,
      question5: 2,
      question6: 2,
      question7: 2,
      question8: 2,
      question9: 2,
      question10: 2,
      question11: 2,
      question13: 2,
      question14: 2,
      question15: 2,
      exceptionComments: '',
      followUpComments: '',
      dateCreated: '',
      dateEdited: '',
      reviewCreatedBy: '',
      editedBy: '',
    };
    dispatch(newQualityAssurance(qualityAssuranceDetailForm));
    setOpen(true);
  };

  const columnsData = [
    {
      field: 'QualityAssuranceReviewId',
      headerName: 'Quality Assurance ID',
      sortable: false,
      flex: 1,
    },
    {
      field: 'reviewDate',
      headerName: 'Review Date',
      sortable: false,
      flex: 1,
      type: 'date',
    },
    {
      field: 'lastReviewDate',
      headerName: 'Last Review Date',
      sortable: false,
      flex: 1,
      type: 'date',
    },
    {
      field: 'nextReviewDate',
      headerName: 'Next Review Date',
      sortable: false,
      flex: 1,
      type: 'date',
    },
  ];

  return (
    <>
      <GridContainer container>
        <Grid item xs={6}>
          <NoteHeading variant='h5'>
            To edit quality assurance please click on particular row
          </NoteHeading>
        </Grid>
        <LeftGrid item xs={6}>
          <Button variant='contained' onClick={openNewQualityAssurance}>
            New Quality Assurance
          </Button>
        </LeftGrid>
      </GridContainer>
      <DataGridContainer>
        <div style={{ height: 670, width: '100%' }}>
          <div style={{ display: 'flex', height: '100%' }}>
            <div style={{ flexGrow: 1 }}>
              <DataGrid
                //getRowHeight={() => 'auto'}
                columns={columnsData}
                rows={qualityAssuranceData.data}
                rowCount={qualityAssuranceData.total}
                rowsPerPageOptions={[10, 25, 50]}
                pageSize={qualityAssuranceData.pageSize}
                pagination
                paginationMode='server'
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }
                onPageSizeChange={(newPageSize) =>
                  setQualityAssuranceData((old) => ({
                    ...old,
                    pageSize: newPageSize,
                  }))
                }
                onPageChange={(newPage) => {
                  setQualityAssuranceData((old) => ({ ...old, page: newPage + 1 }));
                }}
                loading={qualityAssuranceData.isLoading}
                onRowClick={(param) => qualityAssurancRowClick(param.row)}
                disableColumnFilter
                disableColumnMenu
              />
            </div>
          </div>
        </div>      
      </DataGridContainer>
      <QualityAssuranceDialog
        open={open}
        setOpen={setOpen}
        authToken={user?.signInUserSession.accessToken.jwtToken}
        episodeId={episodeId}
        openBackdrop={openBackdrop}
        fetchData={fetchData}
      />
    </>
  );
};
export default QualityAssurance;
